import {
  DEFAULT_TEXT_SCALE,
  MAX_TEXT_SCALE,
  MIN_TEXT_SCALE,
  useGlobalTextScale,
} from '@/core/preferences/export';

export default function TextSizeMenuContent() {
  const { scale, setScale } = useGlobalTextScale();

  return (
    <div className="w-100">
      <div className="d-flex justify-content-between align-items-center mb-1">
        <span className="menu-list-item-label">Text size</span>
        {scale !== DEFAULT_TEXT_SCALE && (
          <button
            className="btn btn-link btn-sm p-0 text-decoration-none"
            onClick={() => setScale(DEFAULT_TEXT_SCALE)}
          >
            Reset
          </button>
        )}
      </div>
      <div className="d-flex align-items-center gap-2">
        <small className="menu-list-text-size-icon">A</small>
        <input
          type="range"
          className="form-range menu-list-text-size-range"
          min={MIN_TEXT_SCALE}
          max={MAX_TEXT_SCALE}
          step={5}
          value={scale}
          onChange={e => setScale(parseInt(e.target.value, 10))}
        />
        <span className="fs-5 menu-list-text-size-icon lh-1">A</span>
      </div>
    </div>
  );
}
